import React from 'react';
import styles from '../assets/styles/LayoutShared.module.css';

interface Column {
  header: string;
  key: string;
  render?: (item: any) => React.ReactNode;
  align?: 'left' | 'right' | 'center';
}

interface DataTableProps {
  title: string;
  columns: Column[];
  data: any[];
}

const DataTable = ({ title, columns, data }: DataTableProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.headerTitle}>
        <h1 className={styles.greenTitle}>{title}</h1>
      </div>

      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              {columns.map((col, index) => (
                <th key={index} style={{ textAlign: col.align || 'left' }}>
                  {col.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((item, i) => (
                <tr key={i}>
                  {columns.map((col, j) => (
                    <td key={j} style={{ textAlign: col.align || 'left' }}>
                      {col.render ? col.render(item) : item[col.key]}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} style={{ textAlign: 'center', padding: '30px', color: '#999' }}>
                  Nenhum registro encontrado.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DataTable;